import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const VideoControlsPlay = ({
	size,
	...props
}: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M10.368 24.3969L23.629 15.872L10.368 7.34709V24.3969ZM9.81085 4.17114L26.4707 14.8691C26.8236 15.1105 27 15.4448 27 15.872C27 16.2992 26.8236 16.6335 26.4707 16.8749L9.81085 27.5729C9.62512 27.6843 9.42082 27.7401 9.19795 27.7401C8.99365 27.7586 8.79863 27.7122 8.6129 27.6008C8.42717 27.5079 8.27859 27.3686 8.16716 27.1829C8.05572 26.9971 8 26.7928 8 26.57V5.17407C8 4.95119 8.05572 4.74689 8.16716 4.56116C8.27859 4.37544 8.42717 4.23614 8.6129 4.14328C8.79863 4.03184 8.99365 3.98541 9.19795 4.00398C9.42082 4.00398 9.62512 4.0597 9.81085 4.17114Z" />
	</svg>
);

export default VideoControlsPlay;
